import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import download from "downloadjs";
import { Button, Input, Select } from "../../../../components/DesignSystem";
import {
  controlCnpjAlphanumericInput as controlCnpjInput,
  controlCpfInput,
  controlZipCodeInput,
} from "../../../../constants/controlInput";
import { useSnackbar } from "../../../../hooks/useSnackbar";

import {
  cnpjAlphanumeric as cnpjMask,
  cpf as cpfMask,
  cepMask,
  validateCnpjAlphanumeric as validateCnpj,
  validateCpf,
  validateEmail,
} from "../../../../constants/validate";

import "./index.scss";
import ConfirmationModal from "../ConfirmationModal";

const UF_LIST = [
  { value: "AC", label: "AC - Acre" },
  { value: "AL", label: "AL - Alagoas" },
  { value: "AP", label: "AP - Amapá" },
  { value: "AM", label: "AM - Amazonas" },
  { value: "BA", label: "BA - Bahia" },
  { value: "CE", label: "CE - Ceará" },
  { value: "DF", label: "DF - Distrito Federal" },
  { value: "ES", label: "ES - Espirito Santo" },
  { value: "GO", label: "GO - Goiás" },
  { value: "MA", label: "MA - Maranhão" },
  { value: "MT", label: "MT - Mato Grosso" },
  { value: "MS", label: "MS - Mato Grosso do Sul" },
  { value: "MG", label: "MG - Minas Gerais" },
  { value: "PR", label: "PR - Paraná" },
  { value: "PB", label: "PB - Paraíba" },
  { value: "PA", label: "PA - Pará" },
  { value: "PE", label: "PE - Pernambuco" },
  { value: "PI", label: "PI - Piauí" },
  { value: "RN", label: "RN - Rio Grande do Norte" },
  { value: "RS", label: "RS - Rio Grande do Sul" },
  { value: "RJ", label: "RJ - Rio de Janeiro" },
  { value: "RO", label: "RO - Rondônia" },
  { value: "RR", label: "RR - Roraima" },
  { value: "SC", label: "SC - Santa Catarina" },
  { value: "SE", label: "SE - Sergipe" },
  { value: "SP", label: "SP - São Paulo" },
  { value: "TO", label: "TO - Tocantins" },
];

function Form({
  btnTitle,
  type,
  isSubmiting,
  handleCallback,
  handleIsSubmit,
  setStep,
}) {
  const snackbar = useSnackbar();
  const dispatch = useDispatch();
  const { debtInfo, payment } = useSelector((state) => state.charge);
  const { user } = useSelector((state) => state.app);
  const { company, partner, cnpj } = debtInfo;

  const [companyName, setCompanyName] = useState(company?.name ?? "");
  // const [cnpj, setCnpj] = useState(company?.cnpj ?? "");
  const [addressStreet, setAddressStreet] = useState(
    company?.addressStreet ?? ""
  );
  const [addressNumber, setAddressNumber] = useState(
    company?.addressNumber ?? ""
  );
  const [companyAddressComplement, setCompanyAddressComplement] = useState("");
  const [addressNeighborhood, setAddressNeighborhood] = useState(
    company?.addressNeighborhood ?? ""
  );
  const [addressCity, setAddressCity] = useState(company?.addressCity ?? "");
  const [addressUF, setAddressUF] = useState(company?.addressUF ?? "");
  const [addressCountry, setAddressCountry] = useState("Brasil");
  const [addressZipCode, setAddressZipCode] = useState(
    company?.addressZipCode ?? ""
  );

  const [partnerName, setPartnerName] = useState(user?.name);
  const [partnerNationality, setPartnerNationality] = useState(
    partner?.nationality ?? ""
  );
  const [partnerCivilStatus, setPartnerCivilStatus] = useState(
    partner?.civilStatus ?? ""
  );
  const [partnerOffice, setPartnerOffice] = useState(partner?.office ?? "");
  const [partnerDocumentRg, setPartnerDocumentRg] = useState(
    partner?.documentRg ?? ""
  );
  const [partnerDocumentRgIssuer, setPartnerDocumentRgIssuer] = useState(
    partner?.documentRgIssuer ?? ""
  );
  const [partnerCpf, setPartnerCpf] = useState(user?.cpf ?? "");
  const [partnerAddressStreet, setPartnerAddressStreet] = useState(
    partner?.addressStreet ?? ""
  );
  const [partnerAddressNumber, setPartnerAddressNumber] = useState(
    partner?.addressNumber ?? ""
  );
  const [partnerAddressComplement, setPartnerAddressComplement] = useState("");
  const [partnerAddressNeighborhood, setPartnerAddressNeighborhood] = useState(
    partner?.addressNeighborhood ?? ""
  );
  const [partnerAddressCity, setPartnerAddressCity] = useState(
    partner?.addressCity ?? ""
  );
  const [partnerAddressUF, setPartnerAddressUF] = useState(
    partner?.addressUF ?? ""
  );
  const [partnerAddressCountry, setPartnerAddressCountry] = useState(
    partner?.addressCountry ?? ""
  );
  const [partnerAddressZipCode, setPartnerAddressZipCode] = useState(
    partner?.addressZipCode ?? ""
  );

  const [email, setEmail] = useState(user?.email);
  const [companyCities, setCompanyCities] = useState([]);
  const [partnerCities, setPartnerCities] = useState([]);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [confirmationModalIsOpen, setConfirmationModalIsOpen] = useState(false);

  useEffect(() => {
    async function getCities() {
      setIsLoadingCities(true);
      const partnerCitiesFound = await fetchCities(partner.addressUF);
      const companyCitiesFound = await fetchCities(company.addressUF);
      setIsLoadingCities(false);
      setPartnerCities(partnerCitiesFound);
      setCompanyCities(companyCitiesFound);
    }

    if (!isSubmiting) {
      getCities();
    }
  }, [isSubmiting]);

  function handleBlurDefault(value) {
    return value !== "";
  }

  function handleBlurEmail(email) {
    return validateEmail(email);
  }

  function handleBlurCnpj() {
    return validateCnpj(removeMask(cnpj));
  }

  /* Company's handle */
  function handleBlurZipCode(value) {
    return value.replace(/\D/g, "").length === 8;
  }

  function handleChangeCnpj(value, evt) {
    controlCnpjInput(cnpj, value, evt);

    // setCnpj(value);
  }

  function handleChangeZipCode(value, evt) {
    controlZipCodeInput(addressZipCode, value, evt);

    setAddressZipCode(value);
  }

  async function handleChangeAddressUF(value) {
    setIsLoadingCities(true);
    setAddressUF(value);
    setAddressCity("");
    const citiesFound = await fetchCities(value);
    setCompanyCities(citiesFound);
    setIsLoadingCities(false);
  }

  /* Partner's handle */
  function handleBlurCpf(value) {
    return validateCpf(removeMask(value));
  }

  function handleChangePartnerCpf(value, evt) {
    controlCpfInput(partnerCpf, value, evt);

    setPartnerCpf(value);
  }

  function handleChangePartnerZipCode(value, evt) {
    controlZipCodeInput(partnerAddressZipCode, value, evt);

    setPartnerAddressZipCode(value);
  }

  async function handleChangeAddressPartnerUF(value) {
    setIsLoadingCities(true);
    setPartnerAddressUF(value);
    setPartnerAddressCity("");
    const citiesFound = await fetchCities(value);
    setPartnerCities(citiesFound);
    setIsLoadingCities(false);
  }

  function handleCloseModalConfirmation() {
    setConfirmationModalIsOpen(false);
  }

  async function handleSubmit(event) {
    const companyInfo = {
      name: companyName,
      cnpj: cnpj,
      addressStreet: addressStreet,
      addressNumber: addressNumber,
      addressNeighborhood: addressNeighborhood,
      addressComplement: companyAddressComplement,
      addressCity: addressCity,
      addressUF: addressUF,
      addressCountry: addressCountry,
      addressZipCode: addressZipCode,
    };
    const partnerInfo = {
      name: partnerName,
      cpf: partnerCpf,
      email,
      addressStreet: partnerAddressStreet,
      addressNumber: partnerAddressNumber,
      addressComplement: partnerAddressComplement,
      addressNeighborhood: partnerAddressNeighborhood,
      addressCity: partnerAddressCity,
      addressUF: partnerAddressUF,
      addressCountry: partnerAddressCountry,
      addressZipCode: partnerAddressZipCode,
      nationality: partnerNationality,
      civilStatus: partnerCivilStatus,
      office: partnerOffice,
      documentRg: partnerDocumentRg,
      documentRgIssuer: partnerDocumentRgIssuer,
    };
        const body = {
      case_id: debtInfo.id,
      proposal_id: payment.proposalId,
      company: { ...companyInfo },
      partner: { ...partnerInfo },
    };
    dispatch({
      type: "CHANGE_DEBT_INFO",
      payload: { company: companyInfo, partner: partnerInfo },
    });
    setStep("minute");
    handleIsSubmit(true);
    try {
      let response = await axios.post("/proposal/create-protocol", body);
      let { signatureUrl } = response.data;
      setStep("billet");
      await axios.post("/case/generate-billet", {
        documentId: response.data.documentId,
      });
      response = await axios.get(`/case/download-billets/${debtInfo.id}`);
      const file = window.atob(response.data);
      download(file, "Boleto", "application/pdf");
      window.open(signatureUrl);
      dispatch({
        type: "CHANGE_DEBT_INFO",
        payload: {
          status: "WAITING",
          signatureUrl: response.data.signatureUrl,
        },
      });
      handleCallback();
    } catch (error) {
      if (error.response.status === 409) {
        snackbar("Houve um erro ao gerar minuta, pois a proposta já foi aceita");
      }
      snackbar("Houve um erro ao gerar minuta");
    } finally {
      setStep("minute");
      handleIsSubmit(false);
    }
  }

  function handleSaveForm(event) {
    event.preventDefault();
    setConfirmationModalIsOpen(true);
  }

  async function handleFakeSubmit() {
    handleIsSubmit(true);
    const companyInfo = {
      name: companyName,
      cnpj: cnpj,
      addressStreet: addressStreet,
      addressNumber: addressNumber,
      addressNeighborhood: addressNeighborhood,
      addressCity: addressCity,
      addressUF: addressUF,
      addressCountry: addressCountry,
      addressZipCode: addressZipCode,
    };
    const partnerInfo = {
      name: partnerName,
      cpf: partnerCpf,
      email,
      addressStreet: partnerAddressStreet,
      addressNumber: partnerAddressNumber,
      addressNeighborhood: partnerAddressNeighborhood,
      addressCity: partnerAddressCity,
      addressUF: partnerAddressUF,
      addressCountry: partnerAddressCountry,
      addressZipCode: partnerAddressZipCode,
      nationality: partnerNationality,
      civilStatus: partnerCivilStatus,
      office: partnerOffice,
      documentRg: partnerDocumentRg,
      documentRgIssuer: partnerDocumentRgIssuer,
    };

    dispatch({
      type: "CHANGE_DEBT_INFO",
      payload: { company: { ...companyInfo }, partner: { ...partnerInfo } },
    });

    await new Promise((resolve) => setTimeout(resolve, 2000));
    dispatch({
      type: "CHANGE_DEBT_INFO",
      payload: { status: "WAITING_APPROVAL" },
    });
    handleIsSubmit(false);
    // handleCallback()
  }

  async function fetchCities(uf) {
    const response = await axios.get(
      `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`
    );
    const citiesFound = response.data.map((city) => ({
      label: city.nome,
      value: city.nome,
    }));

    return citiesFound;
  }

  function removeMask(value) {
    return value.replace(/[^a-zA-Z0-9 ]/g, "").replace(/\s/g, "");
  }

  function checkValidate() {
    // return (
    //   companyName !== "" &&
    //   cnpj !== "" &&
    //   addressStreet !== "" &&
    //   addressNumber !== "" &&
    //   addressNeighborhood !== "" &&
    //   addressCity !== "" &&
    //   addressCountry !== "" &&
    //   addressUF !== "" &&
    //   addressZipCode !== "" &&
    //   partnerName !== "" &&
    //   partnerCpf !== "" &&
    //   partnerNationality !== "" &&
    //   partnerCivilStatus !== "" &&
    //   partnerOffice !== "" &&
    //   partnerAddressStreet !== "" &&
    //   partnerAddressNumber !== "" &&
    //   partnerAddressNeighborhood !== "" &&
    //   partnerAddressCity !== "" &&
    //   partnerAddressCountry !== "" &&
    //   partnerAddressUF !== "" &&
    //   partnerAddressZipCode !== "" &&
    //   firstWitnessName !== "" &&
    //   firstWitnessEmail !== "" &&
    //   firstWitnessCpf !== "" &&
    //   secondWitnessName !== "" &&
    //   secondWitnessEmail !== "" &&
    //   secondWitnessCpf !== "" &&
    //   validateCpf(removeMask(partnerCpf)) &&
    //   handleBlurZipCode(addressZipCode) &&
    //   handleBlurZipCode(partnerAddressZipCode) &&
    //   handleBlurPassword(password, 'checkValidate') &&
    //   handleBlurConfirmPassword(confirmPassword, 'checkValidate') &&
    //   validateCnpj(removeMask(cnpj))
    // )
    return true;
  }

  return (
    <div className="debt-form">
      <ConfirmationModal
        show={confirmationModalIsOpen}
        onClose={handleCloseModalConfirmation}
        onConfirmation={handleSubmit}
      />
      <form onSubmit={handleSaveForm}>
        <div className="debt-form__station">
          <h6>Estabelecimento</h6>
          <Input
            value={companyName}
            label="Nome do estabelecimento"
            placeholder="Nome do estabelecimento"
            type="text"
            required
            // onChange={(value) => setCompanyName(value)}
          />
          <Input
            value={cnpjMask(cnpj)}
            label="CNPJ"
            placeholder="CNPJ"
            type="text"
            required
            maxLength={18}
            // onChange={(value, evt) => handleChangeCnpj(value, evt)}
            onBlur={handleBlurCnpj}
          />
          <Input
            value={addressStreet}
            label="Endereço"
            placeholder="Endereço"
            type="text"
            required
            onChange={(value) => setAddressStreet(value)}
            onBlur={handleBlurDefault}
          />
          <Input
            value={addressNumber}
            label="Número"
            placeholder="Número"
            type="number"
            required
            onChange={(value) => setAddressNumber(value)}
            onBlur={handleBlurDefault}
          />
          <Input
            value={companyAddressComplement}
            label="Complemento"
            placeholder="Complemento"
            type="text"
            required
            onChange={(value) => setCompanyAddressComplement(value)}
            onBlur={handleBlurDefault}
          />
          <Input
            value={addressNeighborhood}
            label="Bairro"
            placeholder="Bairro"
            type="text"
            required
            onChange={(value) => setAddressNeighborhood(value)}
            onBlur={handleBlurDefault}
          />
          <Select
            value={addressUF}
            label="Estado"
            placeholder="Estado"
            type="text"
            required
            onChange={(value) => handleChangeAddressUF(value)}
            onBlur={handleBlurDefault}
            options={UF_LIST}
          />
          <Select
            value={addressCity}
            label="Cidade"
            placeholder="Cidade"
            type="text"
            required
            isLoading={isLoadingCities}
            disabled={companyCities.length === 0}
            onChange={(value) => setAddressCity(value)}
            onBlur={handleBlurDefault}
            options={companyCities}
          />
          <Input
            value={addressCountry}
            label="País"
            placeholder="País"
            type="text"
            required
            // onChange={(value) => setAddressCountry(onlyLetters(value))}
            onBlur={handleBlurDefault}
          />
          <Input
            value={cepMask(addressZipCode)}
            label="CEP"
            placeholder="00000-000"
            type="text"
            required
            maxLength={9}
            onChange={(value, evt) => handleChangeZipCode(value, evt)}
            onBlur={(value) => handleBlurZipCode(value)}
          />
        </div>
        <div className="debt-form__responsible">
          <h6>Sócio</h6>
          <Input
            value={partnerName}
            label="Nome completo"
            placeholder="Nome completo"
            type="text"
            required
            // onChange={(value) => setPartnerName(value)}
          />
          <Input
            value={partnerNationality}
            label="Nacionalidade"
            placeholder="Nacionalidade"
            type="text"
            required
            onChange={(value) => setPartnerNationality(value)}
          />
          <Input
            value={partnerCivilStatus}
            label="Estado civil"
            placeholder="Estado civil"
            type="text"
            required
            onChange={(value) => setPartnerCivilStatus(value)}
          />
          <Input
            value={partnerOffice}
            label="Profissão"
            placeholder="Profissão"
            type="text"
            required
            onChange={(value) => setPartnerOffice(value)}
          />
          <Input
            value={partnerDocumentRg}
            label="RG"
            placeholder="00-000-000-0"
            type="text"
            required
            onChange={(value) => setPartnerDocumentRg(value)}
          />
          <Input
            value={partnerDocumentRgIssuer}
            label="Emissor do RG"
            placeholder="Emissor do RG"
            type="text"
            required
            onChange={(value) => setPartnerDocumentRgIssuer(value)}
          />
          <Input
            value={cpfMask(partnerCpf)}
            label="CPF"
            placeholder="CPF"
            type="text"
            required
            maxLength={14}
            // onChange={(value, evt) => handleChangePartnerCpf(value, evt)}
            onBlur={(value) => handleBlurCpf(value)}
          />
          <Input
            value={partnerAddressStreet}
            label="Endereço"
            placeholder="Endereço"
            type="text"
            required
            onChange={(value) => setPartnerAddressStreet(value)}
            onBlur={handleBlurDefault}
          />
          <Input
            value={partnerAddressNumber}
            label="Número"
            placeholder="Número"
            type="number"
            required
            onChange={(value) => setPartnerAddressNumber(value)}
            onBlur={handleBlurDefault}
          />
          <Input
            value={partnerAddressComplement}
            label="Complemento"
            placeholder="Complemento"
            type="text"
            required
            onChange={(value) => setPartnerAddressComplement(value)}
            onBlur={handleBlurDefault}
          />
          <Input
            value={partnerAddressNeighborhood}
            label="Bairro"
            placeholder="Bairro"
            type="text"
            required
            onChange={(value) => setPartnerAddressNeighborhood(value)}
            onBlur={handleBlurDefault}
          />
          <Select
            value={partnerAddressUF}
            label="Estado"
            placeholder="Estado"
            type="text"
            required
            onChange={(value) => handleChangeAddressPartnerUF(value)}
            onBlur={handleBlurDefault}
            options={UF_LIST}
          />
          <Select
            value={partnerAddressCity}
            label="Cidade"
            placeholder="Cidade"
            type="text"
            required
            isLoading={isLoadingCities}
            disabled={partnerCities.length === 0}
            onChange={(value) => setPartnerAddressCity(value)}
            onBlur={handleBlurDefault}
            options={partnerCities}
          />
          <Input
            value={partnerAddressCountry}
            label="País"
            placeholder="País"
            type="text"
            required
            onChange={(value) => setPartnerAddressCountry(value)}
            onBlur={handleBlurDefault}
          />
          <Input
            value={cepMask(partnerAddressZipCode)}
            label="CEP"
            placeholder="00000-00"
            type="text"
            required
            maxLength={9}
            onChange={(value, evt) => handleChangePartnerZipCode(value, evt)}
            onBlur={(value) => handleBlurZipCode(value)}
          />
        </div>

        <div className="debt-form__credentials">
          <div>
            <h6>Credenciais</h6>
            <p>
              Você irá usar este e-mail para entrar na plataforma quando for
              necessário.
            </p>
          </div>
          <Input
            value={email}
            label="Email"
            placeholder="Email"
            type="email"
            required
            onChange={(value) => setEmail(value)}
            onBlur={(value) => handleBlurEmail(value)}
          />
        </div>

        <Button contained type="submit" disabled={!checkValidate()}>
          {btnTitle}
        </Button>
        {/* <Button
          contained
          type="button"
          onClick={handleFakeSubmit}
        >
          {btnTitle}
        </Button> */}
      </form>
    </div>
  );
}

export default Form;
